import React from 'react';
import { AlertTitle, AlertView, Poppins } from 'src/common';
import { ValidationErrorItem } from 'src/utils/csv';

interface CsvValidationErrorsProps {
  errors: ValidationErrorItem[];
}

export const CsvValidationErrors: React.FC<CsvValidationErrorsProps> = ({ errors }) => {
  if (errors.length === 0) return null;

  return (
    <AlertView>
      {errors.map((error) => (
        <AlertTitle key={JSON.stringify(error.errors)}>
          <div style={{ fontStyle: 'italic' }}>
            <Poppins color="error" px={16} weight={600}>
              Error in row {error.rowIndex + 1}:
            </Poppins>
            <div />
            {error.errors.map((e, idx) => (
              <Poppins px={14} color="error" css="display: block" key={idx}>
                {e.message}
              </Poppins>
            ))}
          </div>
        </AlertTitle>
      ))}
    </AlertView>
  );
};
